module.exports = __webpack_public_path__ + "media/images/ask-cindy-ep-5cf3b7a080891283aecc14ee575aaff9.jpg";